/** Layout presets — aspect ratio + width/radius tokens live in SCSS. */
export const GALLERY_LAYOUTS = {
  vehicle: "vehicle",
  room: "room",
  hero: "hero",
};
